export const LOAD_ITEMS = "LOAD_ITEMS"
export const loadItemsAction = items => ({
   type: LOAD_ITEMS,
   payload: items
})